export enum InvoiceType {
    Unknown = 0,
    Invoice,
    Refund,
    OneOf,
}
